import React, { Component } from 'react'
import { Map, GoogleApiWrapper } from 'google-maps-react'

const mapStyles = {
  width: '320px',
  height: '120px',
}

const containerStyle = {
  position: 'relative',
  // width: '100%',
  // height: '100%'
}

export class MapContainer extends Component {
  state = {
    showingInfoWindow: false, //Hides or the shows the infoWindow
    activeMarker: {}, //Shows the active marker upon click
    selectedPlace: {}, //Shows the infoWindow to the selected place upon a marker
  }

  render() {
    const { lat, lon } = this.props

    return (
      <Map
        google={this.props.google}
        zoom={14}
        containerStyle={containerStyle}
        style={mapStyles}
        initialCenter={{
          lat: lat,
          lng: lon,
        }}
      />
    )
  }
}

export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_MAPS_JAVASCRIPT_KEY,
})(MapContainer)
